﻿import {Core} from "../../Base/Core";
import {UIBase} from "../Tools/Base/UIBase";
import {ChestButton} from "../Tools/ChestButton";
import {RightPanelManager} from "../RightPanelManager";
import {BottomPanelButtons} from "../BottomPanelButtons";
import {LeftPanelManager} from "../LeftPanelManager";
import {isIOS} from "../../../dpCommonPortHelper";

export class UIGame extends UIBase {
    Awake() {
        super.Awake();

        this.bottomButtons = this.addChild(new BottomPanelButtons());
        this.chestBtn = this.addChild(new ChestButton());
        this.leftPanel = this.addChild(new LeftPanelManager());
        this.rightPanel = this.addChild(new RightPanelManager());
    }

    Init() {
        super.Init();

        this.fitLayout = this.fitLayout.bind(this);

        this.leftPanel.Init();
        this.rightPanel.Init();
        Core.app.events.on("resize", this.fitLayout);

        this.fitLayout();
    }

    fitLayout(viewport = Core.app.viewport) {
        let bottomButtonsRect = viewport.clone();
        bottomButtonsRect.height = viewport.width * 0.2;
        bottomButtonsRect.y = viewport.height * (isIOS() ? 0.95 : 0.99) - bottomButtonsRect.height; // Hack for iphone12 home line
        this.bottomButtons.fitLayout(bottomButtonsRect);

        let padding = viewport.width * 0.01;
        let sideButtonSize = new PIXI.Rectangle(
            padding,
            0,
            viewport.width * 0.1,
            viewport.width * 0.1
        );

        let sidePanelRect = new PIXI.Rectangle(
            padding,
            viewport.height * 0.15,
            sideButtonSize.width,
            viewport.height * 0.8
        );
        this.leftPanel.fitLayout(sidePanelRect);

        sidePanelRect.x = viewport.width - sideButtonSize.width - padding;
        this.rightPanel.fitLayout(sidePanelRect);
    }

    Show() {
        super.Show();
    }

    Update() {
        this.leftPanel.Update();
        this.rightPanel.Update();
        this.bottomButtons.Update();
    }
}
